import { render, staticRenderFns } from "./locale-changer.vue?vue&type=template&id=4dbdf7cb&scoped=true"
import script from "./locale-changer.vue?vue&type=script&lang=js"
export * from "./locale-changer.vue?vue&type=script&lang=js"
import style0 from "./locale-changer.vue?vue&type=style&index=0&id=4dbdf7cb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbdf7cb",
  null
  
)

export default component.exports